<template>
    <div class="msgDstail">
        <div class="breadcrumb">消息详情
            <el-button type="primary" class="right_f" @click="cancel">取消</el-button>
            <el-button type="primary" class="right_f" @click="msgDstail(0)">保存</el-button>
        </div>

        <div style="margin-top:20px">
            <el-form ref="form" :model="form" label-width="160px">
                <el-form-item label="消息状态：" required>
                    <el-input v-model="form.msgStatus" class="myInput" disabled></el-input>
                </el-form-item>
                <el-form-item label="消息用途：" required>
                    <el-input v-model="form.msgPurpose" class="myInput" disabled></el-input>
                </el-form-item>
                <el-form-item label="消息类型:" required>
                    <el-select v-model="form.msgType" style="width:40%;" disabled>
                        <el-option label="类型一" value="1"></el-option>
                        <el-option label="类型二" value="2"></el-option>
                        <el-option label="类型三" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="推送范围:" required>
                    <el-input type="textarea" :autosize="{minRows: 3}" class="msgContent" v-model="form.pushContentList" disabled></el-input>
                </el-form-item>
                <el-form-item label="封面图标:" v-if="form.coverPic" required>
                    <div>
                        <img :src="form.coverPic" class="logoImg">
                    </div>
                </el-form-item>
                <el-form-item label="标题：" v-if="form.msgType!='3'" required>
                    <el-input v-model="form.msgHeadline" placeholder="" class="myInput" disabled></el-input>
                </el-form-item>
                <el-form-item label="副标题：" v-if="form.msgType=='1'" required>
                    <el-input v-model="form.msgSubheadline" placeholder="" class="myInput" disabled></el-input>
                </el-form-item>
                <el-form-item label="消息内容：" v-if="form.msgType!='1'" required>
                    <el-input type="textarea" :autosize="{minRows: 3}" class="msgContent" placeholder="请输入消息内容" v-model="form.msgContent" disabled></el-input>
                </el-form-item>
                <el-form-item label="跳转h5地址：" v-if="form.msgType=='1'" required>
                    <el-input v-model="form.redirectH5Url" placeholder="" class="myInput" disabled></el-input>
                </el-form-item>
            </el-form>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: {
                    coverPic: "",
                    msgPurpose: "",
                    msgType: "1",
                    msgStatus: "",
                    msgHeadline: "",
                    msgSubheadline: "",
                    msgContent: "",
                    pushContentList: "",
                    redirectH5Url: ""
                },
                options: []
            }
        },
        mounted() {
            this.getMsgDetail();
        },
        methods: {
            cancel() {
                let url = location.href;
                location.href = url.replace("msgDetail", "msgPush");
            },
            getMsgDetail() {
                let url = this.$util.domain + "/adminapi/v1/secretary/detail";

                this.$http({
                    url,
                    method: 'GET',
                    params: {
                        msgId: this.$util.getUrlParam("id")
                    }
                }).then(response => {
                    if (response.data.error == 10000) {
                        let data = response.data.data;
                        let pushContentList = data.pushContentList;
                        if (data.pushRange == 1) {
                            pushContentList = "全部学校";
                        } else if ((data.pushRange == 2)) {
                            pushContentList = this.getschoolandunid(pushContentList);
                        }
                        this.form = {
                            pushContentList,
                            coverPic: data.coverPic,
                            msgStatus: data.msgStatus == 0 ? "草稿" : "已推送",
                            msgPurpose: data.msgPurpose,
                            msgType: data.msgType + "",
                            msgContent: data.msgContent,
                            msgHeadline: data.msgHeadline,
                            msgSubheadline: data.msgSubheadline,
                            redirectH5Url: data.redirectH5Url
                        }
                    } else {
                        this.$util.errorMsg("网络开小差");
                    }
                })

            },
            //获取所有学校
            getschoolandunid(str) {
                let url = this.$util.domain + '/adminapi/v1/basicTools/allSchools';
                this.$http({
                    url,
                    method: 'GET'
                }).then((response) => {
                    if (response.data.error == 10000) {
                        response.data.data.splice(0, 1);
                        this.options = response.data.data;//给option数组赋值，这里要在下拉列表里面展示出来
                        let myArr = str.split(",");
                        console.log(myArr);
                        let newArr = [];
                        this.options.forEach(item => {
                            myArr.forEach(ele => {
                                if (item.rootUnid == ele) {
                                    newArr.push(item.name)
                                }
                            })
                        });

                        this.form.pushContentList = newArr.join(",");
                    } else {
                        this.$util.errorMsg(response.data.message, '提示');
                    }
                })
            },
        }
    }
</script>

<style>
    .msgDstail {
        min-height: calc(100vh - 60px);
    }

    .msgContent {
        width: 45%;
    }

    .myInput {
        width: 45%;
        display: inline-block;
        margin-right: 10px;
    }

    .logoImg {
        width: 30%;
    }
</style>


// WEBPACK FOOTER //
// msgDetail.vue?5ffdbff2